import {ProjectItem} from "@/models/ProjectItem";

import { defineComponent } from 'vue';

export default defineComponent({
    name: 'ProjectItemStore',
    props: {
        activeProjectItem: ProjectItem,
    },
});